var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTtdLogoWhite = function SvgTtdLogoWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f4g2hjzhpa",
    x1: "14.749%",
    x2: "88.989%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.213%",
    stopColor: "#FFF",
    stopOpacity: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.418.747c0-.066.009-.132.026-.197.11-.398.52-.632.918-.523l6.586 1.8c.325.09.55.384.55.721v6.43h6.47c.412 0 .747.335.747.748v6.262c0 .413-.335.748-.747.748h-6.47v6.43c0 .337-.225.632-.55.72l-6.586 1.802c-.398.108-.809-.126-.918-.524-.017-.064-.026-.13-.026-.197V.747z",
    transform: "translate(-88 -152) translate(88.199 152) translate(7.535 8.143)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f4g2hjzhpa)",
    d: "M4.387 16.736H7.67c.412 0 .747-.335.747-.748V9.726c0-.413-.335-.747-.747-.747H.747c-.412 0-.747.334-.747.747v6.262c0 .413.335.748.747.748h3.639z",
    transform: "translate(-88 -152) translate(88.199 152) translate(7.535 8.143)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTtdLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ttd-logo-white.fd2b13435a502dd5cf23a0e0afdeddc9.svg";